import React from "react";
import style from "./InsightsStrategies.module.scss";
import styles from "./SkinHealthHome.module.scss";
import TestIcon from "../../../static/images/banner-image.png";
import { useNavigate } from "react-router-dom";

export const InsightsStrategies = ({ loading, cards, layoutDetails, chips, toggle }) => {
  const navigate = useNavigate();

  return (
    <div className="">
      <div className={style.title}>Insights and Strategies</div>
      <div className={style.chip_list}>
        {layoutDetails?.filters?.map((item) => (
          <button key={item?.id} onClick={() => toggle(item?.id)} className={`${style.chip} ${chips.includes(item?.id) ? style.active : ""}`}>
            {item?.name}
          </button>
        ))}
      </div>
      <div className={style.bottom_card_container}>
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <div key={i} data-testid="shimmer-card" className={`${style.bottom_card} ${styles.shimmer}`} style={{ height: 90 }} />
            ))
          : cards?.map((item) => (
              <div
                key={item?.id}
                className={style.bottom_card}
                onClick={() => {
                  navigate("/content", {
                    state: {
                      contentURL: item?.contentURL,
                      name: item?.name,
                    },
                  });
                }}
              >
                <div className={style.card_text}>{item?.name}</div>
                <div className={style.card_image}>
                  <img
                    src={item?.menuIcon || TestIcon}
                    alt={item?.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = TestIcon;
                    }}
                  />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};
